"use client"

import { ThinkingOrb } from "thinking-orbs"

import type { ThinkingOrbState } from "./thinking-orb-state"
import { pickOrbState } from "./thinking-orb-state"

export { pickOrbState }
export type { ThinkingOrbState }

export const AiThinkingOrb = ({
	state = "working",
	size = 20,
	className,
	ariaLabel,
}: {
	state?: ThinkingOrbState
	size?: 20 | 64
	className?: string
	ariaLabel?: string
}) => {
	return (
		<ThinkingOrb
			state={state}
			size={size}
			theme="auto"
			aria-label={ariaLabel ?? "Thinking"}
			className={className}
		/>
	)
}
